import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    idx: (number | string)[];
    p_open: string;
}

// 팝업 노출 상태 변경
export const usePostPopupState = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.post(CONSOLE_API_ROUTES.POPUP_STATE, body);
            return res.data;
        },
    });
};
